export const RESPONDENT_DEFAULT_URL = `${process.env.REACT_APP_DOMAIN}/v3/respondent`
export const API_ROOT_URL = `${process.env.REACT_APP_URL_RESPONDENT_API || RESPONDENT_DEFAULT_URL}/api/v1.0`;
